module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Light TH.98a52438.eot";